// @flow

import type {Dispatch} from '../../reducers/types';
import type {LocaleKeys} from '../types/locale';

import {addLocaleData} from 'react-intl';
//$FlowFixMe
import de from 'react-intl/locale-data/de';
//$FlowFixMe
import en from 'react-intl/locale-data/en';
//$FlowFixMe
import es from 'react-intl/locale-data/es';
//$FlowFixMe
import fr from 'react-intl/locale-data/fr';
//$FlowFixMe
import ja from 'react-intl/locale-data/ja';
//$FlowFixMe
import ko from 'react-intl/locale-data/ko';
//$FlowFixMe
import pt from 'react-intl/locale-data/pt';
//$FlowFixMe
import ru from 'react-intl/locale-data/ru';
//$FlowFixMe
import zh from 'react-intl/locale-data/zh';
import {bindActionCreators} from 'redux';
import acceptLanguage from 'accept-language';
import 'intl';
// TODO PUBLISHER-3405
//  The flow has been updated and now we need to fix what is below.
//  Need to update react-intl.
//  Remove $FlowFixMe and edit the code.
import 'intl/locale-data/jsonp/en';
import 'intl/locale-data/jsonp/ru';
import 'intl/locale-data/jsonp/ko';
import 'intl/locale-data/jsonp/ja';
import 'intl/locale-data/jsonp/de';
import 'intl/locale-data/jsonp/zh';
import 'intl/locale-data/jsonp/es';
import 'intl/locale-data/jsonp/pt';
import 'intl/locale-data/jsonp/fr';
import {applicationLocale} from '../../reducers/application';
import {cookie} from '../cookie-policy-checker';
import cookiesName from '../cookies-name';
import getCookieParams from '../get-cookieparams';
import {acceptLocales, sanitizeLocale} from '../translations';

const setupLocales = (dispatch: Dispatch): void | LocaleKeys => {
  const url = new URL(window.location.href);
  acceptLanguage.languages(acceptLocales);

  const localeParams = url.searchParams.get('locale');

  const locale: LocaleKeys = sanitizeLocale(
    localeParams || cookie.get(cookiesName.locale) || acceptLanguage.get(window.navigator.language)
  );

  cookie.set(cookiesName.locale, locale, {
    ...getCookieParams(url.hostname),
    expires: null
  });

  if (localeParams) {
    delete url.searchParams.delete('locale');

    return window.location.replace(url.toString());
  }

  bindActionCreators(applicationLocale, dispatch)(locale);

  addLocaleData([...en, ...ru, ...ko, ...ja, ...de, ...zh, ...es, ...pt, ...fr]);

  return locale;
};

export default setupLocales;
